import { ComponentType } from "react";

import ThemeProvider from "@/context/ThemeProvider";

const withThemeProvider = <P extends object>(Component: ComponentType<P>) => {
  return (props: P) => (
    <ThemeProvider>
      <Component {...props} />
    </ThemeProvider>
  );
};

export default withThemeProvider;
